import { render, staticRenderFns } from "./AddInstantMedicationModal.vue?vue&type=template&id=2fccceaa&scoped=true"
import script from "./AddInstantMedicationModal.vue?vue&type=script&lang=js"
export * from "./AddInstantMedicationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fccceaa",
  null
  
)

export default component.exports